import { useState } from "react";

import {
    Actions,
    COMPANY_ACTIONS,
    DEVICE_ACTIONS,
    DEVICE_MODEL_ACTIONS,
    FILE_ACTIONS,
    GROUP_ACTIONS,
    LICENSE_ACTIONS,
    PRODUCT_CODE_ACTIONS,
    ROLE_ACTIONS,
    TASK_ACTIONS,
    TASK_GROUP_ACTIONS,
    USER_ACTIONS
} from "../../types";

export const useDialog = (closeMenu?: () => void) => {
    const [isOpenDialog, setIsOpenDialog] = useState({
        [COMPANY_ACTIONS.CompanyLevelManualChange]: false,
        [COMPANY_ACTIONS.CreateCompany]: false,
        [COMPANY_ACTIONS.CustomResourceLimits]: false,
        [COMPANY_ACTIONS.DeleteCompanies]: false,
        [COMPANY_ACTIONS.MergeCompanies]: false,
        [COMPANY_ACTIONS.TransferCompanies]: false,
        [DEVICE_ACTIONS.AddDevice]: false,
        [DEVICE_ACTIONS.AssignCanPackage]: false,
        [DEVICE_ACTIONS.AutoSync]: false,
        [DEVICE_ACTIONS.CreateTask]: false,
        [DEVICE_ACTIONS.ExportDeviceData]: false,
        [DEVICE_ACTIONS.GenerateUnlockKey]: false,
        [DEVICE_ACTIONS.ImportDevices]: false,
        [DEVICE_ACTIONS.MoveDevices]: false,
        [DEVICE_ACTIONS.NoTableActions]: false,
        [DEVICE_ACTIONS.TaskDetails]: false,
        [DEVICE_ACTIONS.TransferDevice]: false,
        [DEVICE_MODEL_ACTIONS.CloneModel]: false,
        [DEVICE_MODEL_ACTIONS.CreateModel]: false,
        [DEVICE_MODEL_ACTIONS.DeleteModels]: false,
        [DEVICE_MODEL_ACTIONS.EditCompatibility]: false,
        [DEVICE_MODEL_ACTIONS.EditModel]: false,
        [FILE_ACTIONS.DeleteFiles]: false,
        [FILE_ACTIONS.UploadFiles]: false,
        [GROUP_ACTIONS.CreateGroup]: false,
        [GROUP_ACTIONS.DeleteDeviceGroups]: false,
        [GROUP_ACTIONS.MoveDeviceGroup]: false,
        [LICENSE_ACTIONS.CreateDesktopLicense]: false,
        [LICENSE_ACTIONS.CreateOfflineLicense]: false,
        [LICENSE_ACTIONS.DeleteDesktopLicense]: false,
        [LICENSE_ACTIONS.DeleteOfflineLicense]: false,
        [LICENSE_ACTIONS.EditDesktopLicense]: false,
        [PRODUCT_CODE_ACTIONS.AddProductCode]: false,
        [PRODUCT_CODE_ACTIONS.DeleteProductCode]: false,
        [ROLE_ACTIONS.CreateRole]: false,
        [ROLE_ACTIONS.DeleteRoles]: false,
        [ROLE_ACTIONS.EditRole]: false,
        [TASK_ACTIONS.CancelTasks]: false,
        [TASK_GROUP_ACTIONS.CancelTasks]: false,
        [TASK_GROUP_ACTIONS.RetryFailedTasks]: false,
        [USER_ACTIONS.InviteUser]: false,
        [USER_ACTIONS.EditUser]: false,
        [USER_ACTIONS.DeleteUsers]: false,
        [USER_ACTIONS.ResendInvitation]: false
    });

    const openDialog = (action: Actions) => {
        closeMenu?.();
        setIsOpenDialog({ ...isOpenDialog, [action]: true });
    };

    const closeDialog = (action: Actions) =>
        setIsOpenDialog({ ...isOpenDialog, [action]: false });

    return { isOpenDialog, openDialog, closeDialog };
};
